export const TTVR_TYPES = {
  PredefinedViewsController: Symbol.for('PredefinedViewsController'),
  PredefinedViewActivator: Symbol.for('PredefinedViewActivator'),
  PredefinedViewsStore: Symbol.for('PredefinedViewsStore'),
  IPVStoreConfig: Symbol.for('IPVStoreConfig'),
  IPVOrientationProvider: Symbol.for('IPVOrientationProvider'),
  TTVRScreenClassification: Symbol.for('TTVRScreenClassification'),
  IBoundingPointsContext: Symbol.for('IBoundingPointsContext'),
  ISAXOrientationContext: Symbol.for('ISAXOrientationContext'),
  AlgorithmHelperFactory: Symbol.for('AlgorithmHelperFactory')
};
